// extracted by mini-css-extract-plugin
module.exports = {"tagSectionList":"TagSectionList_tagSectionList__2uQRB","tagSectionItem":"TagSectionList_tagSectionItem__KfyJ0"};